/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Agent_Development_Autonomy_Desc8Inputs */

const en_svc_ai_agent_development_autonomy_desc8 = /** @type {(inputs: Svc_Ai_Agent_Development_Autonomy_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agents built for action, they plan multi-step tasks, call your tools, and drive them to completion without a human in the loop.`)
};

const ar_svc_ai_agent_development_autonomy_desc8 = /** @type {(inputs: Svc_Ai_Agent_Development_Autonomy_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`وكلاء مصممون للعمل، يخططون للمهام متعددة الخطوات، ويستدعون أدواتك، ويوصلونها إلى الاكتمال دون تدخل بشري.`)
};

const bn_svc_ai_agent_development_autonomy_desc8 = /** @type {(inputs: Svc_Ai_Agent_Development_Autonomy_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অ্যাকশনের জন্য তৈরি এজেন্ট, মাল্টি-স্টেপ টাস্ক প্ল্যান করে, আপনার টুল কল করে, এবং মানুষের হস্তক্ষেপ ছাড়াই সেগুলো শেষ করে।`)
};

const de_svc_ai_agent_development_autonomy_desc8 = /** @type {(inputs: Svc_Ai_Agent_Development_Autonomy_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agenten, die für den Einsatz konzipiert sind. Sie planen mehrstufige Aufgaben, rufen Ihre Tools auf und führen sie zum Abschluss, ohne menschliches Eingreifen.`)
};

const es_svc_ai_agent_development_autonomy_desc8 = /** @type {(inputs: Svc_Ai_Agent_Development_Autonomy_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agentes creados para la acción, planifican tareas de varios pasos, usan sus herramientas y las llevan a su finalización sin intervención humana.`)
};

const fr_svc_ai_agent_development_autonomy_desc8 = /** @type {(inputs: Svc_Ai_Agent_Development_Autonomy_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agents conçus pour l'action, ils planifient des tâches en plusieurs étapes, utilisent vos outils et les mènent à leur terme sans intervention humaine.`)
};

const pt_svc_ai_agent_development_autonomy_desc8 = /** @type {(inputs: Svc_Ai_Agent_Development_Autonomy_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agentes criados para a ação, eles planejam tarefas de várias etapas, usam suas ferramentas e as conduzem até a conclusão sem intervenção humana.`)
};

const zh_svc_ai_agent_development_autonomy_desc8 = /** @type {(inputs: Svc_Ai_Agent_Development_Autonomy_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为行动而构建的代理，它们计划多步骤任务，调用您的工具，并在没有人参与的情况下推动它们完成。`)
};

const tr_svc_ai_agent_development_autonomy_desc8 = /** @type {(inputs: Svc_Ai_Agent_Development_Autonomy_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eylem için tasarlanmış ajanlar, çok adımlı görevleri planlar, araçlarınızı kullanır ve insan eli değmeden uçtan uca taşır.`)
};

const ru_svc_ai_agent_development_autonomy_desc8 = /** @type {(inputs: Svc_Ai_Agent_Development_Autonomy_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Агенты, созданные для действий: планируют многоэтапные задачи, используют ваши инструменты и доводят их до конца без участия человека.`)
};

const pl_svc_ai_agent_development_autonomy_desc8 = /** @type {(inputs: Svc_Ai_Agent_Development_Autonomy_Desc8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agenci stworzeni do działania. Planują wieloetapowe zadania, używają twoich narzędzi i dowożą je do końca bez udziału człowieka.`)
};

/**
* | output |
* | --- |
* | "Agents built for action, they plan multi-step tasks, call your tools, and drive them to completion without a human in the loop." |
*
* @param {Svc_Ai_Agent_Development_Autonomy_Desc8Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_agent_development_autonomy_desc8 = /** @type {((inputs?: Svc_Ai_Agent_Development_Autonomy_Desc8Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Agent_Development_Autonomy_Desc8Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_agent_development_autonomy_desc8(inputs)
	if (locale === "bn") return bn_svc_ai_agent_development_autonomy_desc8(inputs)
	if (locale === "de") return de_svc_ai_agent_development_autonomy_desc8(inputs)
	if (locale === "es") return es_svc_ai_agent_development_autonomy_desc8(inputs)
	if (locale === "fr") return fr_svc_ai_agent_development_autonomy_desc8(inputs)
	if (locale === "pt") return pt_svc_ai_agent_development_autonomy_desc8(inputs)
	if (locale === "zh") return zh_svc_ai_agent_development_autonomy_desc8(inputs)
	if (locale === "tr") return tr_svc_ai_agent_development_autonomy_desc8(inputs)
	if (locale === "ru") return ru_svc_ai_agent_development_autonomy_desc8(inputs)
	if (locale === "pl") return pl_svc_ai_agent_development_autonomy_desc8(inputs)
	return en_svc_ai_agent_development_autonomy_desc8(inputs)
});
export { svc_ai_agent_development_autonomy_desc8 as "svc_ai-agent-development_AUTONOMY_desc" }